"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _request = _interopRequireDefault(require("../../request"));
// 报表模块
var _default = exports.default = {
  getKpiList: function getKpiList(module, data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: "/protected/pc/report/kpi/".concat(module),
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportKpiData: function exportKpiData(module, data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: "/protected/pc/report/kpi/".concat(module, "/export"),
      method: 'post',
      data: data,
      cancelToken: cancelToken,
      responseType: 'blob'
    });
  },
  getOrderListByMonth: function getOrderListByMonth(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/order/brand',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getStoreDetailList: function getStoreDetailList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/order/store',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportStoreDetailList: function exportStoreDetailList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/order/store/export',
      method: 'post',
      data: data,
      cancelToken: cancelToken,
      responseType: 'blob'
    });
  },
  getSRStoreOrderList: function getSRStoreOrderList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/retailor/sales/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportSRStoreOrderList: function exportSRStoreOrderList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/retailor/sales/export',
      method: 'post',
      data: data,
      cancelToken: cancelToken,
      responseType: 'blob'
    });
  },
  carpac_regionCarpList: function carpac_regionCarpList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/carparc/regionCarpList',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  carpac_rimCarpList: function carpac_rimCarpList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/carparc/rimCarpList',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  carpac_brandCarpList: function carpac_brandCarpList(data, cancelToken) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/carparc/brandCarpList',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  getProviceCityByRole: function getProviceCityByRole(data) {
    return (0, _request.default)({
      module: 'CORE',
      url: '/protected/carparc/regionSelect',
      method: 'post',
      data: data
    });
  },
  getStoreDetailTotal: function getStoreDetailTotal(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/retailor/sales/total',
      method: 'post',
      data: data
    });
  },
  exportChannelDevelopment: function exportChannelDevelopment(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/sr/channelDevelopment/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  exportWorkEfficiency: function exportWorkEfficiency(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/sr/workingEfficiency/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  getBailianList: function getBailianList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/baiLian/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportBailianList: function exportBailianList(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/baiLian/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  exportBailianSumList: function exportBailianSumList(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/baiLian/summaryExport',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  getStoreOnlineOrderList: function getStoreOnlineOrderList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciOrder/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportStoreOnlineOrderList: function exportStoreOnlineOrderList(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciOrder/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  getStoreOnlineTMList: function getStoreOnlineTMList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciStoreOrder/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportStoreOnlineTMList: function exportStoreOnlineTMList(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciStoreOrder/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  getCciTireStoreOrderList: function getCciTireStoreOrderList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciTireStoreOrder/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportCciTireStoreOrderList: function exportCciTireStoreOrderList(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciTireStoreOrder/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  },
  getFDPList: function getFDPList(data, cancelToken) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciFdpTireDetail/list',
      method: 'post',
      data: data,
      cancelToken: cancelToken
    });
  },
  exportFDPList: function exportFDPList(data) {
    return (0, _request.default)({
      module: 'REPORT',
      url: '/protected/pc/report/cciFdpTireDetail/export',
      method: 'post',
      data: data,
      responseType: 'blob'
    });
  }
};